import { render, staticRenderFns } from "./CourseLibrary.vue?vue&type=template&id=72ed5dbe&scoped=true&"
import script from "./CourseLibrary.vue?vue&type=script&lang=js&"
export * from "./CourseLibrary.vue?vue&type=script&lang=js&"
import style0 from "./CourseLibrary.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CourseLibrary.vue?vue&type=style&index=1&id=72ed5dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed5dbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
